export default __webpack_public_path__ + "static/media/AI_banner.132d30bf.png";